import React, { useEffect, useState } from "react";
import "./flip.css";

const FlipUnit = ({ label, value }) => {
  const [prevValue, setPrevValue] = useState(value);
  const [flip, setFlip] = useState(false);

  useEffect(() => {
    if (value !== prevValue) {
      setFlip(true);
      setTimeout(() => {
        setFlip(false);
        setPrevValue(value);
      }, 600);
    }
  }, [value, prevValue]);

  return (
    <div className="flip-unit">
      <div className={`card ${flip ? "flip" : ""}`}>
        <div className="card-face card-front">{prevValue}</div>
        <div className="card-face card-back">{value}</div>
      </div>
      <span className="label">{label}</span>
    </div>
  );
};

export default function FlipCountdown({ targetDate }) {
  const [timeLeft, setTimeLeft] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  useEffect(() => {
    if (!targetDate) {
      setTimeLeft({
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00",
      });
      return;
    }

    const countdownInterval = setInterval(() => {
      const now = new Date().getTime();
      const target = new Date(targetDate).getTime();
      const diff = target - now;

      if (Number.isNaN(target) || diff <= 0) {
        setTimeLeft({
          days: "00",
          hours: "00",
          minutes: "00",
          seconds: "00",
        });
        clearInterval(countdownInterval);
        return;
      }

      const days = String(Math.floor(diff / (1000 * 60 * 60 * 24))).padStart(2, "0");
      const hours = String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(2, "0");
      const minutes = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(2, "0");
      const seconds = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");

      setTimeLeft({ days, hours, minutes, seconds });
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, [targetDate]);

  return (
    <div className="flip-countdown">
      <FlipUnit label="Days" value={timeLeft.days} />
      <FlipUnit label="Hours" value={timeLeft.hours} />
      <FlipUnit label="Min" value={timeLeft.minutes} />
      <FlipUnit label="Sec" value={timeLeft.seconds} />
    </div>
  );
}
